import React from "react";
import styles from "./paginate.module.css";

const Pagination = ({ paginate, isLoading, onPageChange }) => {
  if (!paginate || !paginate.totalPages) return null;
  const { page, totalPages } = paginate;
  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  const goToPage = (newPage) => {
    if (newPage < 1 || newPage > totalPages || newPage === page) return;
    onPageChange(newPage);
  };

  if (isLoading) return null;

  return (
    <div className={styles.paginationWrap}>
      <nav aria-label="Page navigation">
        <ul className="pagination mb-0">
          <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
            <button
              className="page-link"
              aria-label="Previous"
              onClick={() => goToPage(page - 1)}
              disabled={page === 1}
            >
              <span aria-hidden="true">&laquo;</span>
              <span className="sr-only">Previous</span>
            </button>
          </li>

          {pages.map((p) => (
            <li key={p} className={`page-item ${p === page ? "active" : ""}`}>
              <button
                className="page-link"
                onClick={() => goToPage(p)}
                disabled={p === page}
              >
                {p}
              </button>
            </li>
          ))}

          <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
            <button
              className="page-link"
              aria-label="Next"
              onClick={() => goToPage(page + 1)}
              disabled={page === totalPages}
            >
              <span aria-hidden="true">&raquo;</span>
              <span className="sr-only">Next</span>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Pagination;
